[
    {
        "id": "tin-can-skyline",
        "title": "Tin Can Skyline",
        "family": "build",
        "summary": "Teams raid the cupboards and build the tallest free-standing tower they can from tins alone.",
        "steps": [
            "Scavenge: unopened tins from the kitchen",
            "Build on the floor or a low table for 90 seconds",
            "No tape, no leaning on walls or furniture",
            "Hands off: the tower must stand for 5 seconds while the TV counts"
        ],
        "durationSec": 90,
        "scavengeSec": 60,
        "objects": [
            "unopened tins",
            "a tape measure or ruler"
        ],
        "minPlayers": 4,
        "teamSize": 4,
        "space": "room",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Seated players build on a coffee table while teammates bring them the tins.",
        "sabotage": [
            "time-steal",
            "hidden-penalty"
        ],
        "potValue": 1500,
        "tags": [
            "teams",
            "stacking",
            "ai-narratable"
        ]
    },
    {
        "id": "the-library-bridge",
        "title": "The Library Bridge",
        "family": "build",
        "summary": "Span a gap between two piles of books with a bridge of books strong enough to carry a full mug of water.",
        "steps": [
            "Scavenge: paperbacks, hardbacks and a mug",
            "The TV sets the gap: two hand-widths between the piles",
            "Build for 2 minutes using only books",
            "Place the mug of water in the middle and count to five: no collapse, no spill"
        ],
        "durationSec": 120,
        "scavengeSec": 75,
        "objects": [
            "books",
            "a mug",
            "cold water",
            "a tea towel"
        ],
        "minPlayers": 4,
        "teamSize": 3,
        "space": "room",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Build the bridge on a coffee table from a seated position; teammates fetch the books.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 2500,
        "tags": [
            "teams",
            "engineering",
            "ai-narratable"
        ]
    },
    {
        "id": "the-book-domino-run",
        "title": "The Book Domino Run",
        "family": "build",
        "summary": "The whole group stands books on end in one long line, then tips the first and hopes the last one falls.",
        "steps": [
            "Scavenge: as many books as you can carry",
            "Stand them on end in a single line across the floor for 2 minutes",
            "One push on the first book; no touching after that",
            "The TV counts every book that fell; gold if the last one goes"
        ],
        "durationSec": 120,
        "scavengeSec": 90,
        "objects": [
            "books",
            "boxed games",
            "DVD or CD cases"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "room",
        "noise": "lively",
        "remoteSafe": false,
        "seatedAlternative": "Seated players build their stretch of the run along a coffee table or tray on their lap, joined to the floor line.",
        "sabotage": [
            "hidden-penalty",
            "time-steal"
        ],
        "potValue": 2500,
        "tags": [
            "whole-group",
            "chain-reaction"
        ]
    },
    {
        "id": "the-card-keep",
        "title": "The Card Keep",
        "family": "build",
        "summary": "Pairs build the tallest house of cards they can from a pack of playing cards. No folding, no tape.",
        "steps": [
            "Scavenge: a pack of playing cards per pair",
            "Build on a table or a hard floor for 3 minutes",
            "Cards may not be bent or folded",
            "Hands off for 5 seconds; the TV scores storeys, not cards"
        ],
        "durationSec": 180,
        "scavengeSec": 45,
        "objects": [
            "packs of playing cards",
            "a hard tray or board if the floor is carpeted"
        ],
        "minPlayers": 4,
        "teamSize": 2,
        "space": "sofa",
        "noise": "quiet",
        "remoteSafe": true,
        "seatedAlternative": "Already seated: build on a tray or coffee table.",
        "sabotage": [
            "time-steal",
            "hidden-penalty"
        ],
        "potValue": 3000,
        "tags": [
            "pairs",
            "stacking",
            "ai-narratable"
        ]
    },
    {
        "id": "the-loo-roll-turret",
        "title": "The Loo Roll Turret",
        "family": "build",
        "summary": "Alternate toilet rolls and paper plates (or cereal box card) to build a turret taller than the shortest player's knee.",
        "steps": [
            "Scavenge: toilet or kitchen rolls, paper plates or flat card",
            "Rolls and plates must alternate, one layer at a time",
            "Build for 90 seconds",
            "Hands off for 5 seconds; gold for every layer above the knee line"
        ],
        "durationSec": 90,
        "scavengeSec": 60,
        "objects": [
            "toilet rolls",
            "kitchen rolls",
            "paper plates",
            "flattened cereal boxes"
        ],
        "minPlayers": 4,
        "teamSize": 3,
        "space": "room",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Build on a coffee table from the sofa; teammates fetch the rolls.",
        "sabotage": [
            "time-steal",
            "fake-instruction"
        ],
        "potValue": 1500,
        "tags": [
            "teams",
            "stacking",
            "ai-narratable"
        ]
    },
    {
        "id": "the-c-hunt",
        "title": "The C Hunt",
        "family": "relay",
        "summary": "One at a time, each team member fetches something beginning with C until the team has three, then the next letter is called.",
        "steps": [
            "Teams line up by the sofa",
            "The TV calls a letter: first up, C",
            "One runner at a time walks out and back with one object; tag the next runner",
            "Three objects per letter, then the TV calls the next letter",
            "No repeats; the TV and the other team judge each object"
        ],
        "durationSec": 180,
        "scavengeSec": 0,
        "objects": [
            "anything in the house beginning with the called letter"
        ],
        "minPlayers": 4,
        "teamSize": 4,
        "space": "house",
        "noise": "loud",
        "remoteSafe": true,
        "seatedAlternative": "Seated players are the team's judge and caller: they name an object in the room beginning with the letter and a runner fetches it.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 2000,
        "tags": [
            "teams",
            "scavenger-hunt",
            "ai-narratable",
            "phone-friendly"
        ]
    },
    {
        "id": "the-rainbow-run",
        "title": "The Rainbow Run",
        "family": "relay",
        "summary": "Fetch one object for each colour of the rainbow, in order, one runner per colour.",
        "steps": [
            "The TV shows the order: red, orange, yellow, green, blue, indigo, violet",
            "Runner one fetches something red and lays it down; runner two goes for orange",
            "Walk, don't run on the stairs",
            "Lay out the rainbow in front of the TV; the other team may challenge any colour"
        ],
        "durationSec": 150,
        "scavengeSec": 0,
        "objects": [
            "anything clearly one colour"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "house",
        "noise": "loud",
        "remoteSafe": true,
        "seatedAlternative": "Seated players spot colours from where they sit and send a runner, or supply items from their own pockets and bags.",
        "sabotage": [
            "time-steal",
            "hidden-penalty"
        ],
        "potValue": 2000,
        "tags": [
            "scavenger-hunt",
            "whole-group",
            "ai-narratable",
            "phone-friendly"
        ]
    },
    {
        "id": "the-potato-courier",
        "title": "The Potato Courier",
        "family": "relay",
        "summary": "Carry a potato on a tablespoon from one end of the room to the other, handing over spoon to spoon.",
        "steps": [
            "Scavenge: a tablespoon each and one potato (an apple will do)",
            "Line up along the room, an arm's length apart",
            "Pass the potato spoon to spoon; free hands behind your back",
            "Dropped it? Back to the start. Three full crossings to win"
        ],
        "durationSec": 120,
        "scavengeSec": 45,
        "objects": [
            "a tablespoon each",
            "a potato or apple"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "room",
        "noise": "loud",
        "remoteSafe": false,
        "seatedAlternative": "Sit in a circle and pass a grape or a ping-pong ball spoon to spoon instead.",
        "sabotage": [
            "hidden-penalty",
            "time-steal"
        ],
        "potValue": 1500,
        "tags": [
            "whole-group",
            "balance"
        ]
    },
    {
        "id": "the-washing-line",
        "title": "The Washing Line",
        "family": "relay",
        "summary": "Two players hold a length of string; teammates take turns pegging socks onto it until the line is full.",
        "steps": [
            "Scavenge: string or a dressing-gown cord, clothes pegs, socks",
            "Two holders keep the line taut; they may not help",
            "Runners fetch one sock from the pile and peg it on, one at a time",
            "Ten socks pegged and none on the floor: gold"
        ],
        "durationSec": 120,
        "scavengeSec": 60,
        "objects": [
            "string or a dressing-gown cord",
            "clothes pegs",
            "socks"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "room",
        "noise": "lively",
        "remoteSafe": false,
        "seatedAlternative": "Seated players are the line holders, or peg socks onto a cord tied between two chair backs within reach.",
        "sabotage": [
            "hidden-penalty",
            "time-steal"
        ],
        "potValue": 1500,
        "tags": [
            "whole-group",
            "ai-narratable"
        ]
    },
    {
        "id": "the-cushion-conveyor",
        "title": "The Cushion Conveyor",
        "family": "relay",
        "summary": "Pass a cushion down the line, over the head then under the legs, alternating. Last person runs, er, walks it to the front.",
        "steps": [
            "Scavenge: one cushion per team",
            "Stand in a line facing the same way",
            "Over, under, over, under; the last player walks to the front and starts again",
            "First team back to its original order wins the gold"
        ],
        "durationSec": 90,
        "scavengeSec": 20,
        "objects": [
            "a cushion per team"
        ],
        "minPlayers": 6,
        "teamSize": 3,
        "space": "room",
        "noise": "loud",
        "remoteSafe": false,
        "seatedAlternative": "Seated teams pass the cushion along the sofa, alternating left hand and right hand, and the end player swaps seats with the front.",
        "sabotage": [
            "time-steal",
            "fake-instruction"
        ],
        "potValue": 1000,
        "tags": [
            "teams",
            "warm-up"
        ]
    },
    {
        "id": "the-forbidden-words",
        "title": "The Forbidden Words",
        "family": "communication",
        "summary": "Describe household objects to your team without saying any of the three banned words on your phone.",
        "steps": [
            "The describer's phone shows an object and three banned words",
            "Describe it; no pointing at it if it's in the room",
            "Teammates shout guesses; skip costs 5 seconds",
            "Say a banned word and the card is burned",
            "Swap describers each minute"
        ],
        "durationSec": 180,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 4,
        "teamSize": 4,
        "space": "sofa",
        "noise": "loud",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 2000,
        "tags": [
            "teams",
            "word-game",
            "phone-friendly"
        ]
    },
    {
        "id": "the-grapevine",
        "title": "The Grapevine",
        "family": "communication",
        "summary": "A secret message is whispered from guest to guest around the room. The last guest types what they heard.",
        "steps": [
            "The first guest reads a short message on their phone, once",
            "Whisper it to the next guest, once only, no repeats",
            "Pass it all the way round",
            "The last guest types it in; the TV scores how many words survived"
        ],
        "durationSec": 120,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 5,
        "teamSize": null,
        "space": "sofa",
        "noise": "quiet",
        "remoteSafe": false,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "fake-instruction"
        ],
        "potValue": 1500,
        "tags": [
            "whole-group",
            "phone-friendly"
        ]
    },
    {
        "id": "the-sketch-courier",
        "title": "The Sketch Courier",
        "family": "communication",
        "summary": "One player draws the phrase on their phone, no letters or numbers, and the team guesses from the paper.",
        "steps": [
            "Scavenge: paper and pens",
            "The artist sees a phrase; everyone else looks away",
            "Draw for 45 seconds; no letters, numbers or mouthing",
            "Teammates guess; a new artist takes over for each phrase"
        ],
        "durationSec": 180,
        "scavengeSec": 30,
        "objects": [
            "paper",
            "pens or pencils"
        ],
        "minPlayers": 4,
        "teamSize": 4,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 2000,
        "tags": [
            "teams",
            "drawing",
            "phone-friendly"
        ]
    },
    {
        "id": "the-blind-errand",
        "title": "The Blind Errand",
        "family": "communication",
        "summary": "A blindfolded player walks slowly across a cleared room and picks up a named object, guided only by their partner's voice.",
        "steps": [
            "Clear the floor of bags, cables and anything to trip on",
            "Blindfold the walker with a scarf; the guide stays put on the sofa",
            "The phone names the object to collect; only the guide sees it",
            "Walk slowly, hands out in front; the guide speaks, never touches",
            "Bring it back to the sofa within 90 seconds"
        ],
        "durationSec": 90,
        "scavengeSec": 20,
        "objects": [
            "a scarf for a blindfold",
            "objects already in the room"
        ],
        "minPlayers": 4,
        "teamSize": 2,
        "space": "room",
        "noise": "lively",
        "remoteSafe": false,
        "seatedAlternative": "The blindfolded player stays seated and is guided to find a named object on a tray of six items in front of them.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 2500,
        "tags": [
            "blindfold",
            "pairs"
        ]
    },
    {
        "id": "back-to-back",
        "title": "Back to Back",
        "family": "communication",
        "summary": "Sitting back to back, one player arranges five objects and describes the layout; their partner copies it exactly.",
        "steps": [
            "Scavenge: two matching sets of five objects (spoons, coins, mugs, pens, a remote)",
            "Sit back to back; the arranger lays out their set",
            "Describe the layout for 90 seconds; the copier may ask questions",
            "Turn round: the TV checks each object's place and direction"
        ],
        "durationSec": 90,
        "scavengeSec": 60,
        "objects": [
            "two spoons",
            "two coins",
            "two mugs",
            "two pens",
            "two small matching items"
        ],
        "minPlayers": 4,
        "teamSize": 2,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated: use trays on laps, or sit at opposite ends of the sofa.",
        "sabotage": [
            "fake-instruction"
        ],
        "potValue": 2000,
        "tags": [
            "pairs",
            "ai-narratable"
        ]
    },
    {
        "id": "the-packing-list",
        "title": "The Packing List",
        "family": "memory",
        "summary": "Each guest adds one object from the room to an imaginary suitcase. Everyone must recite the whole list before adding theirs.",
        "steps": [
            "Sit in a circle; the TV picks who starts",
            "Say \"I packed\" plus every item so far, then add one you can see in the room",
            "One slip and the chain breaks; the TV counts how far you got",
            "Gold for every item past ten"
        ],
        "durationSec": 180,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 4,
        "teamSize": null,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "fake-instruction",
            "hidden-penalty"
        ],
        "potValue": 2000,
        "tags": [
            "whole-group",
            "memory-chain",
            "phone-friendly",
            "ai-narratable"
        ]
    },
    {
        "id": "the-covered-tray",
        "title": "The Covered Tray",
        "family": "memory",
        "summary": "Fifteen objects on a tray, thirty seconds to look, then a tea towel goes over and one or more vanish.",
        "steps": [
            "The Host collects fifteen small objects and lays them on a tray",
            "Everyone looks for 30 seconds, no phones",
            "Cover the tray; the Host secretly removes up to three objects",
            "Uncover: the group agrees what's missing and types it in"
        ],
        "durationSec": 120,
        "scavengeSec": 60,
        "objects": [
            "a tray",
            "a tea towel",
            "fifteen small objects (a key, a peg, a teaspoon, a coin…)"
        ],
        "minPlayers": 3,
        "teamSize": null,
        "space": "sofa",
        "noise": "quiet",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "fake-instruction",
            "hidden-penalty"
        ],
        "potValue": 2000,
        "tags": [
            "whole-group",
            "phone-friendly"
        ]
    },
    {
        "id": "the-shifted-mantelpiece",
        "title": "The Shifted Mantelpiece",
        "family": "memory",
        "summary": "Study one shelf or mantelpiece, leave the room, and come back to spot what's been moved.",
        "steps": [
            "Everyone studies the shelf the TV names for 45 seconds",
            "All but the Host leave the room",
            "The Host makes five changes: swap, turn, move, remove, add",
            "Everyone returns and lists the changes on their phones"
        ],
        "durationSec": 150,
        "scavengeSec": 0,
        "objects": [
            "a shelf, windowsill or mantelpiece with ornaments"
        ],
        "minPlayers": 3,
        "teamSize": null,
        "space": "room",
        "noise": "quiet",
        "remoteSafe": false,
        "seatedAlternative": "Seated players turn to face away (or close their eyes) instead of leaving the room.",
        "sabotage": [
            "fake-instruction",
            "hidden-penalty"
        ],
        "potValue": 2500,
        "tags": [
            "whole-group",
            "observation"
        ]
    },
    {
        "id": "the-shopping-list",
        "title": "The Shopping List",
        "family": "memory",
        "summary": "The Steward reads a sixteen-item shopping list once. Between you, rebuild the whole list.",
        "steps": [
            "Listen: the list is read aloud once, no writing",
            "Each guest types the items they remember on their phone",
            "The TV merges every answer into one list",
            "Gold if the combined list hits fourteen of sixteen"
        ],
        "durationSec": 120,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 3,
        "teamSize": null,
        "space": "sofa",
        "noise": "quiet",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "hidden-penalty",
            "fake-instruction"
        ],
        "potValue": 1500,
        "tags": [
            "ai-narratable",
            "needs-engine",
            "phone-friendly",
            "whole-group"
        ]
    },
    {
        "id": "the-colour-echo",
        "title": "The Colour Echo",
        "family": "memory",
        "summary": "The TV flashes a sequence of colours. Hold up household objects in the same order, one longer sequence each round.",
        "steps": [
            "Scavenge: one object in each of six colours",
            "Watch the sequence on the TV",
            "Each player holds up their colour at the right moment, in order",
            "The sequence grows by one each round; one slip ends it"
        ],
        "durationSec": 180,
        "scavengeSec": 60,
        "objects": [
            "six objects, each a clear different colour"
        ],
        "minPlayers": 3,
        "teamSize": null,
        "space": "room",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Seated players play their colour by tapping it on their phone instead of holding up an object.",
        "sabotage": [
            "time-steal",
            "hidden-penalty"
        ],
        "potValue": 2500,
        "tags": [
            "whole-group",
            "sequence",
            "phone-friendly"
        ]
    },
    {
        "id": "older-than-you",
        "title": "Older Than You",
        "family": "trust",
        "summary": "Everyone fetches something they claim is older than they are. The group decides which claims to believe.",
        "steps": [
            "Scavenge: bring back one object you say is older than you",
            "Each guest has 20 seconds to tell its story",
            "Each phone secretly marks its own claim as true or bluffing",
            "The group votes on every claim; gold for each truth believed and each bluff caught"
        ],
        "durationSec": 240,
        "scavengeSec": 90,
        "objects": [
            "an old book, coin, photo, ornament or tool"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "house",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Seated players pick something already within reach or in their bag, or ask a runner to fetch a named item.",
        "sabotage": [
            "hidden-penalty",
            "fake-instruction"
        ],
        "potValue": 2500,
        "tags": [
            "ai-narratable",
            "bluffing",
            "needs-engine",
            "scavenger-hunt",
            "whole-group"
        ]
    },
    {
        "id": "the-honest-mug",
        "title": "The Honest Mug",
        "family": "trust",
        "summary": "Each guest secretly drops between none and three coins into a mug. Hit the target total exactly and the gold is yours.",
        "steps": [
            "Scavenge: one mug and three coins each",
            "The TV shows the target total",
            "Talk tactics, then one by one drop coins in behind your back",
            "Tip the mug out: exactly on target pays out, one over or under pays nothing"
        ],
        "durationSec": 150,
        "scavengeSec": 30,
        "objects": [
            "a mug",
            "three coins each (buttons will do)"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": false,
        "seatedAlternative": "Already seated: the mug is passed round under a tea towel.",
        "sabotage": [
            "false-digit",
            "hidden-penalty"
        ],
        "potValue": 3000,
        "tags": [
            "whole-group",
            "phone-friendly"
        ]
    },
    {
        "id": "the-champion",
        "title": "The Champion",
        "family": "trust",
        "summary": "The group chooses one champion to stack ten coins one-handed in 30 seconds. Everyone stakes gold on them.",
        "steps": [
            "Debate for 60 seconds: who has the steadiest hand?",
            "Vote on the phones; the most votes becomes champion",
            "Everyone secretly stakes gold from the pot on success or failure",
            "The champion stacks ten coins one-handed in 30 seconds; the TV pays out"
        ],
        "durationSec": 120,
        "scavengeSec": 20,
        "objects": [
            "ten coins"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "hidden-penalty",
            "time-steal"
        ],
        "potValue": 2000,
        "tags": [
            "needs-engine",
            "phone-friendly",
            "voting",
            "whole-group"
        ]
    },
    {
        "id": "the-stepping-stones",
        "title": "The Stepping Stones",
        "family": "trust",
        "summary": "A blindfolded crosser walks a path of tea towels laid flat on the floor, guided by teammates who may each say only one word at a time.",
        "steps": [
            "Clear the floor; lay six tea towels flat as stepping stones",
            "Blindfold the crosser with a scarf",
            "Guides take turns, one word each, to steer them stone to stone",
            "Step off a towel and go back one stone; reach the far side in 2 minutes"
        ],
        "durationSec": 120,
        "scavengeSec": 45,
        "objects": [
            "six tea towels",
            "a scarf for a blindfold"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "room",
        "noise": "lively",
        "remoteSafe": false,
        "seatedAlternative": "The seated crosser is blindfolded and guides a coin across six coasters on a table with a fingertip, steered the same way.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 2500,
        "tags": [
            "blindfold",
            "whole-group"
        ]
    },
    {
        "id": "the-common-purse",
        "title": "The Common Purse",
        "family": "trust",
        "summary": "Each guest secretly chooses on their phone to put gold in or hold it back. The purse only doubles if enough of you are generous.",
        "steps": [
            "Each phone offers: give, or keep back",
            "Discuss for 60 seconds; promises are free",
            "Choose in secret",
            "The TV reveals the total only, not who gave; pass the threshold and the purse doubles"
        ],
        "durationSec": 120,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 4,
        "teamSize": null,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "hidden-penalty"
        ],
        "potValue": 3000,
        "tags": [
            "whole-group",
            "phone-friendly",
            "ai-narratable"
        ]
    },
    {
        "id": "the-humming-choir",
        "title": "The Humming Choir",
        "family": "performance",
        "summary": "One player hums a tune from their phone; no words, no da-da-da. Their team names it.",
        "steps": [
            "The hummer's phone shows a well-known tune (nursery rhymes, carols, anthems, film themes)",
            "Hum it: no words, no clues, no actions",
            "Team guesses within 30 seconds; pass costs 5 seconds",
            "Rotate hummers; gold for every tune named"
        ],
        "durationSec": 150,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 4,
        "teamSize": 4,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 1500,
        "tags": [
            "teams",
            "music"
        ]
    },
    {
        "id": "one-prop-charades",
        "title": "One-Prop Charades",
        "family": "performance",
        "summary": "Team charades, but the actor must use one random household object the other team chose for them in every scene.",
        "steps": [
            "Scavenge: each team fetches three ordinary objects for the other team",
            "The actor's phone shows a film, book or song title",
            "Act it out, silently, and use the prop every time",
            "60 seconds a title; rotate actors and props"
        ],
        "durationSec": 240,
        "scavengeSec": 60,
        "objects": [
            "a colander",
            "a wooden spoon",
            "a sock",
            "a hairbrush",
            "anything harmless"
        ],
        "minPlayers": 6,
        "teamSize": 3,
        "space": "room",
        "noise": "loud",
        "remoteSafe": true,
        "seatedAlternative": "Seated actors perform from the waist up; the prop still has to be used.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 2000,
        "tags": [
            "teams",
            "charades",
            "ai-narratable"
        ]
    },
    {
        "id": "the-living-statues",
        "title": "The Living Statues",
        "family": "performance",
        "summary": "A team freezes into a scene from their phones in ten seconds. The rest of the room has to name it.",
        "steps": [
            "The team's phones show the same scene (a wedding photo, a dentist's waiting room, a penalty shoot-out)",
            "Ten seconds to strike your poses, then freeze",
            "The other guests have 30 seconds to guess",
            "Three scenes per team; gold for each one guessed"
        ],
        "durationSec": 180,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 6,
        "teamSize": 3,
        "space": "room",
        "noise": "lively",
        "remoteSafe": false,
        "seatedAlternative": "Seated players hold a pose from their chair; every scene has a role that sits.",
        "sabotage": [
            "fake-instruction"
        ],
        "potValue": 1500,
        "tags": [
            "teams",
            "tableau"
        ]
    },
    {
        "id": "the-foley-room",
        "title": "The Foley Room",
        "family": "performance",
        "summary": "Hidden behind the sofa, a sound artist makes a noise with a household object. The listeners must name the object.",
        "steps": [
            "Scavenge: each sound artist secretly picks three objects",
            "The artist hides behind the sofa or in the doorway",
            "Make the sound up to three times",
            "Listeners name the object; gold for each one named"
        ],
        "durationSec": 180,
        "scavengeSec": 60,
        "objects": [
            "keys",
            "a cheese grater and spoon",
            "a zip",
            "a cereal box",
            "a pepper mill"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "room",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Listeners close their eyes and the seated artist makes the sound where they sit.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 1500,
        "tags": [
            "whole-group",
            "listening",
            "ai-narratable"
        ]
    },
    {
        "id": "the-auctioneer",
        "title": "The Auctioneer",
        "family": "performance",
        "summary": "Sell a dull household object in 45 seconds without naming it. If the room guesses the object and votes to buy it, gold is paid.",
        "steps": [
            "Scavenge: a plain object from another room, kept hidden",
            "Pitch it for 45 seconds without saying what it is",
            "The room guesses the object, then votes yes or no to buy",
            "Gold if guessed and sold"
        ],
        "durationSec": 240,
        "scavengeSec": 60,
        "objects": [
            "a sponge",
            "a clothes peg",
            "a bottle opener",
            "a plug",
            "any plain object"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "room",
        "noise": "loud",
        "remoteSafe": true,
        "seatedAlternative": "Seated sellers choose something within reach or have a runner fetch it.",
        "sabotage": [
            "hidden-penalty",
            "fake-instruction"
        ],
        "potValue": 2000,
        "tags": [
            "whole-group",
            "ai-narratable"
        ]
    },
    {
        "id": "the-split-recipe",
        "title": "The Split Recipe",
        "family": "hidden-info",
        "summary": "Each phone holds one step of a strange recipe. Without showing screens, rebuild the steps in the right order.",
        "steps": [
            "Each phone shows one recipe step",
            "Read yours out loud as often as you like; never show your screen",
            "Stand (or sit) in the order you think the recipe goes",
            "Lock in the order on the Host's phone; two attempts"
        ],
        "durationSec": 180,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 4,
        "teamSize": null,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated: shuffle seats or just say your position.",
        "sabotage": [
            "fake-instruction"
        ],
        "potValue": 2500,
        "tags": [
            "deduction",
            "whole-group",
            "phone-friendly"
        ]
    },
    {
        "id": "the-vault-sum",
        "title": "The Vault Sum",
        "family": "hidden-info",
        "summary": "Each phone holds one number. The vault opens on the total, but not every number can be trusted.",
        "steps": [
            "Each phone shows one number from 1 to 20",
            "Share your number out loud; never show your screen",
            "Agree the total and enter it on the Host's phone",
            "Two wrong totals and the vault stays shut"
        ],
        "durationSec": 150,
        "scavengeSec": 0,
        "objects": [],
        "minPlayers": 4,
        "teamSize": null,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated.",
        "sabotage": [
            "false-digit"
        ],
        "potValue": 3000,
        "tags": [
            "deduction",
            "whole-group",
            "phone-friendly"
        ]
    },
    {
        "id": "the-hidden-key",
        "title": "The Hidden Key",
        "family": "hidden-info",
        "summary": "The Host hides a real key in the room. Each phone holds one clue to where it is. Pool them and find it.",
        "steps": [
            "Everyone leaves while the Host hides a key and types where it is",
            "Return: each phone shows one clue (\"It is lower than the TV\", \"It is not in anything soft\")",
            "Share clues out loud, never show screens",
            "One guest searches, one spot at a time; three wrong spots and the key is lost"
        ],
        "durationSec": 180,
        "scavengeSec": 0,
        "objects": [
            "a key or other small object",
            "the room's usual furniture"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "room",
        "noise": "lively",
        "remoteSafe": false,
        "seatedAlternative": "Seated players share clues and name the spot; a standing player does the searching.",
        "sabotage": [
            "fake-instruction",
            "time-steal"
        ],
        "potValue": 3000,
        "tags": [
            "deduction",
            "whole-group"
        ]
    },
    {
        "id": "the-colour-lock",
        "title": "The Colour Lock",
        "family": "hidden-info",
        "summary": "Each phone holds one colour and its position in the lock. Lay matching objects out in order to open it.",
        "steps": [
            "Each phone shows a colour and a position, e.g. \"third: green\"",
            "Scavenge: fetch one object in your colour",
            "Say your position, then lay the objects in a row in front of the TV",
            "The Host photographs the row; one wrong colour and the lock jams"
        ],
        "durationSec": 150,
        "scavengeSec": 60,
        "objects": [
            "anything clearly one colour"
        ],
        "minPlayers": 4,
        "teamSize": null,
        "space": "house",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Seated players say their colour and a runner fetches the object, or they use something they're wearing or carrying.",
        "sabotage": [
            "false-digit",
            "fake-instruction"
        ],
        "potValue": 2500,
        "tags": [
            "deduction",
            "whole-group",
            "ai-narratable"
        ]
    },
    {
        "id": "the-odd-object",
        "title": "The Odd Object",
        "family": "hidden-info",
        "summary": "Every phone names the same household object except one, which names a near neighbour. Each guest fetches theirs; the group must decide which object is the real one.",
        "steps": [
            "Each phone names an object (most say \"teaspoon\", one says \"fork\")",
            "Scavenge: fetch your object without telling anyone what it is",
            "Reveal all at once; argue about which is the real one",
            "Vote for the true object; gold if the majority's pick matches the vault"
        ],
        "durationSec": 150,
        "scavengeSec": 60,
        "objects": [
            "ordinary kitchen and household items"
        ],
        "minPlayers": 5,
        "teamSize": null,
        "space": "house",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Seated players type a description of the object instead of fetching it.",
        "sabotage": [
            "fake-instruction",
            "hidden-penalty"
        ],
        "potValue": 2000,
        "tags": [
            "ai-narratable",
            "bluffing",
            "needs-engine",
            "whole-group"
        ]
    },
    {
        "id": "the-coin-column",
        "title": "The Coin Column",
        "family": "dexterity",
        "summary": "Stack coins one-handed into the tallest column you can before the timer ends, then all of you add it up.",
        "steps": [
            "Scavenge: every loose coin in the house",
            "One hand only, the other behind your back",
            "Stack for 60 seconds on a hard surface",
            "Topples count as zero; the TV totals every column"
        ],
        "durationSec": 60,
        "scavengeSec": 60,
        "objects": [
            "coins",
            "a hard surface (tray, table, book)"
        ],
        "minPlayers": 2,
        "teamSize": null,
        "space": "sofa",
        "noise": "quiet",
        "remoteSafe": true,
        "seatedAlternative": "Already seated: stack on a tray or book on your lap.",
        "sabotage": [
            "time-steal",
            "hidden-penalty"
        ],
        "potValue": 1000,
        "tags": [
            "whole-group",
            "stacking",
            "ai-narratable"
        ]
    },
    {
        "id": "the-saucer-slide",
        "title": "The Saucer Slide",
        "family": "dexterity",
        "summary": "Flick coins down a table so they come to rest on a saucer at the far end. Five coins each.",
        "steps": [
            "Scavenge: a saucer or coaster and five coins each",
            "Put the saucer at the far edge of a table",
            "Flick one coin at a time from the near edge",
            "Coins resting on the saucer score; coins off the table score nothing"
        ],
        "durationSec": 150,
        "scavengeSec": 30,
        "objects": [
            "a saucer or coaster",
            "five coins each",
            "a table"
        ],
        "minPlayers": 2,
        "teamSize": null,
        "space": "room",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Pull a chair to the table end or play on a coffee table from the sofa.",
        "sabotage": [
            "hidden-penalty",
            "time-steal"
        ],
        "potValue": 1500,
        "tags": [
            "whole-group",
            "flicking",
            "ai-narratable",
            "phone-friendly"
        ]
    },
    {
        "id": "the-penne-threader",
        "title": "The Penne Threader",
        "family": "dexterity",
        "summary": "Using a single strand of dried spaghetti, pick up penne pieces from a bowl without touching them.",
        "steps": [
            "Scavenge: a bowl of dried penne, a strand of dried spaghetti each",
            "Hold the spaghetti at one end only",
            "Thread as many penne as you can in 60 seconds",
            "Snapped spaghetti? Grab a new strand; the clock keeps going"
        ],
        "durationSec": 60,
        "scavengeSec": 45,
        "objects": [
            "dried penne",
            "dried spaghetti",
            "a bowl"
        ],
        "minPlayers": 2,
        "teamSize": null,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated: the bowl rests on a tray.",
        "sabotage": [
            "time-steal",
            "hidden-penalty"
        ],
        "potValue": 1500,
        "tags": [
            "whole-group",
            "ai-narratable"
        ]
    },
    {
        "id": "the-sock-basket",
        "title": "The Sock Basket",
        "family": "dexterity",
        "summary": "Throw rolled-up socks into a laundry basket from behind a line. Each round the basket moves a step further away.",
        "steps": [
            "Scavenge: a laundry basket and as many paired socks as you can find",
            "Roll each pair into a ball",
            "Everyone throws one sock from behind the line; the basket moves back a step each round",
            "Gold for every sock in the basket after five rounds"
        ],
        "durationSec": 150,
        "scavengeSec": 60,
        "objects": [
            "a laundry basket or bucket",
            "pairs of socks"
        ],
        "minPlayers": 2,
        "teamSize": null,
        "space": "room",
        "noise": "loud",
        "remoteSafe": true,
        "seatedAlternative": "Throw from the sofa; the basket is moved instead of the thrower.",
        "sabotage": [
            "hidden-penalty",
            "time-steal"
        ],
        "potValue": 1000,
        "tags": [
            "whole-group",
            "throwing",
            "ai-narratable"
        ]
    },
    {
        "id": "the-speed-stack",
        "title": "The Speed Stack",
        "family": "dexterity",
        "summary": "Stack ten plastic or paper cups into a pyramid and back down to one pile, as fast as you can, passing to the next player.",
        "steps": [
            "Scavenge: ten plastic or paper cups per team (no glass)",
            "First player stacks a 4-3-2-1 pyramid, then collapses it into one pile",
            "Pass the pile to the next player; everyone has a go",
            "Any cup that falls must be restacked; beat the TV's clock for the gold"
        ],
        "durationSec": 120,
        "scavengeSec": 45,
        "objects": [
            "ten plastic or paper cups per team"
        ],
        "minPlayers": 4,
        "teamSize": 4,
        "space": "sofa",
        "noise": "lively",
        "remoteSafe": true,
        "seatedAlternative": "Already seated: stack on a coffee table or tray.",
        "sabotage": [
            "time-steal",
            "hidden-penalty"
        ],
        "potValue": 2000,
        "tags": [
            "teams",
            "cup-stacking",
            "ai-narratable"
        ]
    }
]
